import { denormalize } from "normalizr";
import { get } from "lodash";
import { group } from "../../../api/schema";

export default state => {
  try {
    const items = state.groups.connectedGroups.ids;

    const denormalized = denormalize(
      { items },
      { items: [group] },
      state.entities
    );
    return {
      data: denormalized.items || [],
      loading: get(state, "groups.connectedGroups.loading", false)
    };
  } catch (err) {
    return [];
  }
};
